module.exports = __webpack_public_path__ + "static/media/08diaoduzhongxinpiaowu.acab0dea.png";